(() => {
  const initialize = (scope) => {
    const roots = scope.matches?.('.beadifique-product') ? [scope] : scope.querySelectorAll('.beadifique-product');
    roots.forEach((root) => {
      if (root.dataset.beadifiqueReady) return;
      root.dataset.beadifiqueReady = 'true';
      const mobile = window.matchMedia('(max-width: 767px)');
      root.querySelectorAll('.beadifique-accordion').forEach((panel) => {
        if (mobile.matches) panel.open = panel.dataset.openMobile === 'true';
      });
      const badge = root.querySelector('[data-beadifique-stock]');
      const source = root.querySelector('[data-online-buffer-product-variants]');
      let stockData;
      try { stockData = JSON.parse(source?.textContent || 'null'); } catch { stockData = null; }
      const updateStock = () => {
        if (!badge || !stockData || badge.dataset.state === 'digital') return;
        const picker = root.querySelector('variant-selects, variant-radios');
        const input = root.querySelector('form[data-type="add-to-cart-form"] input[name="id"]');
        const invalid = picker && 'currentVariant' in picker && !picker.currentVariant;
        const id = picker?.currentVariant?.id || input?.value;
        const variant = invalid ? null : stockData.variants[String(id)];
        let state = 'available';
        let text = badge.dataset.inStock;
        if (!variant) {
          state = 'unavailable';
          text = badge.dataset.unavailable;
        } else {
          const count = Math.max(0, Number(variant.inventory_quantity) - Math.max(0, Number(stockData.buffer)));
          if (!variant.available || (variant.inventory_management && stockData.buffer > 0 && count === 0)) {
            state = 'unavailable';
            text = badge.dataset.soldOut;
          } else if (variant.inventory_management && count > 0) {
            const low = count < 4;
            state = low ? 'low' : 'available';
            const countLabel = low ? badge.dataset.lowCountLabel : badge.dataset.countLabel;
            text = badge.dataset.showCount === 'true' ? countLabel.replace('[count]', String(count)) : (low ? badge.dataset.lowStock : badge.dataset.inStock);
          } else if (variant.inventory_management) {
            state = 'order';
            text = badge.dataset.order;
          }
        }
        badge.dataset.state = state;
        badge.querySelector('[data-stock-label]').textContent = text;
      };
      root.addEventListener('change', () => queueMicrotask(updateStock));
      root.addEventListener('click', (event) => {
        if (event.target.closest('.jdgm-prev-badge, .jdgm-preview-badge')) {
          const reviews = root.querySelector('[data-beadifique-reviews]');
          if (reviews) reviews.open = true;
        }
      }, true);
      updateStock();
    });
  };
  initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:block:select', (event) => {
    const panel = event.target.closest('.beadifique-accordion');
    if (panel) panel.open = true;
  });
})();
